import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// import { AppState } from '@capacitor/app';
import { setLoadingSpinner } from '../actions/shared.action';
import { catchError, exhaustMap, filter, map, mergeMap, of, tap } from 'rxjs';
import { ROUTER_NAVIGATION, RouterNavigatedAction } from '@ngrx/router-store';
import * as fromStudentActions from '../actions/student.action'
import { APIResponse } from 'src/app/models/api-response.model';
import { AppState } from '../app.state';
import { SchoolService } from 'src/app/services/school.service';
import { StudentService } from 'src/app/services/student.service';
import { ModalService } from 'src/app/services/modal.service';
import { getStudentApplication } from '../actions/account.action';
import { Router } from '@angular/router';

@Injectable()
export class StudentEffects {

  getStudents$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.getStudents),
      exhaustMap((action) =>
        this.studentService.getStudents(action?.data).pipe(
          map((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return fromStudentActions.getStudentsSuccess({ data: response });
          }),
          catchError((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return of(fromStudentActions.getStudentsFailed({ data: response?.error?.message }))
          })
        )
      )
    )
  );

  getStudentsSuccess$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.getStudentsSuccess),
      tap(async (action) => {
        this.modalService.hideStudentFilter();
      })
    ),
    { dispatch: false }
  );

  getStudentsFailed$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.getStudentsFailed),
      tap(async (action) => {
        this.modalService.hideStudentFilter();

        if (action.data) {
          this.modalService.errorModal(action?.data)
        } else {
          const message = 'Unkown error ocurred. Please try again later.'
          this.modalService.errorModal(message)
        }
      })
    ),
    { dispatch: false }
  );

  getAssessmentStudentList$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.getAssessmentStudentList),
      exhaustMap((action) =>
        this.studentService.getStudents(action?.data).pipe(
          map((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return fromStudentActions.getAssessmentStudentListSuccess({ data: response?.data ? response : response?.details })
          }),
          catchError((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return of(fromStudentActions.getAssessmentStudentListFailed({ data: response?.error?.message }))
          })
        )
      )
    )
  );

  getAssessmentStudentListSuccess$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.getAssessmentStudentListSuccess),
      tap(async (action) => {
        this.modalService.hideStudentFilter();
      })
    ),
    { dispatch: false }
  );

  getAssessmentStudentListFailed$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.getAssessmentStudentListFailed),
      tap(async (action) => {
        this.modalService.hideStudentFilter();

        if (action.data) {
          this.modalService.errorModal(action?.data)
        } else {
          const message = 'Unkown error ocurred. Please try again later.'
          this.modalService.errorModal(message)
        }
      })
    ),
    { dispatch: false }
  );

  getStudentApplications$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.getStudentApplicationList),
      exhaustMap((action) =>
        this.studentService.getStudentApplications(action?.data).pipe(
          map((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return fromStudentActions.getStudentApplicationListSuccess({ data: response?.details })
          }),
          catchError((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return of(fromStudentActions.getStudentApplicationListFailed({ data: response?.error?.message }))
          })
        )
      )
    )
  );

  updateStudentApplicationStatus$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.updateApplicationStatus),
      exhaustMap((action) =>
        this.studentService.updateApplicationStatus(action?.applicationId, action?.data).pipe(
          map((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return fromStudentActions.updateApplicationStatusSuccess({ applicationId: action?.applicationId, data: response, schoolYearId: action?.schoolYearId })
          }),
          catchError((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return of(fromStudentActions.updateApplicationStatusFailed({ data: response?.error?.message }))
          })
        )
      )
    )
  );

  updateApplicationStatusSuccess$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.updateApplicationStatusSuccess),
      tap(async (action) => {
        await this.modalService.hideUpdateApplicationStatus();
        this.store.dispatch(fromStudentActions.getStudentApplicationList({ data: action?.schoolYearId }));
        this.modalService.successModal(action.data)
      })
    ),
    { dispatch: false }
  );

  updateApplicationStatusFailed$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.updateApplicationStatusFailed),
      tap(async (action) => {
        if (action.data) {
          this.modalService.errorModal(action?.data)
        } else {
          const message = 'Unkown error ocurred. Please try again later.'
          this.modalService.errorModal(message)
        }
      })
    ),
    { dispatch: false }
  );

  getPreEnlistmentList$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.getPreEnlistmentList),
      exhaustMap((action) =>
        this.studentService.getPreEnlistmentList(action?.data).pipe(
          map((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return fromStudentActions.getPreEnlistmentListSuccess({ data: response?.details })
          }),
          catchError((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return of(fromStudentActions.getPreEnlistmentListFailed({ data: response?.error?.message }))
          })
        )
      )
    )
  );

  updatePreEnlistmentStatus$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.updatePreEnlistmentStatus),
      exhaustMap((action) =>
        this.studentService.updatePreEnlistmentStatus(action?.preEnlistmentId, action?.data).pipe(
          map((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return fromStudentActions.updatePreEnlistmentStatusSuccess({ preEnlistmentId: action?.preEnlistmentId, data: response, schoolYearId: action?.schoolYearId })
          }),
          catchError((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return of(fromStudentActions.updatePreEnlistmentStatusFailed({ data: response?.error?.message }))
          })
        )
      )
    )
  );

  updatePreEnlistmentStatusSuccess$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.updatePreEnlistmentStatusSuccess),
      tap(async (action) => {
        await this.modalService.hideUpdatePreEnlistmentStatus();
        this.store.dispatch(fromStudentActions.getPreEnlistmentList({ data: action?.schoolYearId }));
        this.modalService.successModal(action.data)
      })
    ),
    { dispatch: false }
  );

  updatePreEnlistmentStatusFailed$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.updatePreEnlistmentStatusFailed),
      tap(async (action) => {
        if (action.data) {
          this.modalService.errorModal(action?.data)
        } else {
          const message = 'Unkown error ocurred. Please try again later.'
          this.modalService.errorModal(message)
        }
      })
    ),
    { dispatch: false }
  );

  generateStudentAssessment$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.generateStudentAssessment),
      exhaustMap((action) =>
        this.studentService.generateStudentAssessment(action?.student_id, action?.data).pipe(
          map((response) => {
            return fromStudentActions.generateStudentAssessmentSuccess({ student_id: action?.student_id, data: response?.details })
          }),
          catchError((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return of(fromStudentActions.generateStudentAssessmentFailed({ data: response?.error?.message }))
          })
        )
      )
    )
  );

  generateStudentAssessmentSuccess$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.generateStudentAssessmentSuccess),
      tap(async (action) => {
        await this.modalService.hideUpdatePreEnlistmentStatus();
        const message = {
          title: 'Assessment sent',
          message: `The student's assessment has been generated and successfully sent to student portal. An email confirmation has been sent to the student’s registered email address.`
        }
        this.modalService.successModal(message);
        this.store.dispatch(fromStudentActions.getStudentAssessment({ assessment_id: action?.data }));
      })
    ),
    { dispatch: false }
  );

  generateStudentAssessmentFailed$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.generateStudentAssessmentFailed),
      tap(async (action) => {
        if (action.data) {
          this.modalService.errorModal(action?.data)
        } else {
          const message = 'Unkown error ocurred. Please try again later.'
          this.modalService.errorModal(message)
        }
      })
    ),
    { dispatch: false }
  );

  getStudentAssessment$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.getStudentAssessment),
      exhaustMap((action) =>
        this.studentService.getStudentAssessment(action?.assessment_id).pipe(
          map((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return fromStudentActions.getStudentAssessmentSuccess({ data: response?.details })
          }),
          catchError((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return of(fromStudentActions.getStudentAssessmentFailed({ data: response?.error?.message }))
          })
        )
      )
    )
  );

  getStudentAssessmentSuccess$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.getStudentAssessmentSuccess),
      tap(async (action) => {
        this.router.navigateByUrl('/home/registrar/assessment/view-student')
      })
    ),
    { dispatch: false }
  );

  getStudentAssessmentFailed$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.getStudentAssessmentFailed),
      tap(async (action) => {
        if (action.data) {
          this.modalService.errorModal(action?.data)
        } else {
          const message = 'Unkown error ocurred. Please try again later.'
          this.modalService.errorModal(message)
        }
      })
    ),
    { dispatch: false }
  );

  getStudentLatestAssessment$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.getStudentLatestAssessment),
      exhaustMap((action) =>
        this.studentService.getStudentLatestAssessment(action?.student_id).pipe(
          map((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return fromStudentActions.getStudentLatestAssessmentSuccess({ data: response?.details })
          }),
          catchError((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return of(fromStudentActions.getStudentLatestAssessmentFailed({ data: response?.error?.message }))
          })
        )
      )
    )
  );

  getStudentLatestAssessmentSuccess$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.getStudentLatestAssessmentSuccess),
      tap(async (action) => {
        if (action?.data?.length == 0 || !action?.data) {
          const message = 'You have no latest assessment. Please try again later.'
          this.modalService.errorModal(message)
        } else {
          this.router.navigateByUrl('/student/payment/review-assessment')
        }
      })
    ),
    { dispatch: false }
  );

  getStudentLatestAssessmentFailed$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.getStudentLatestAssessmentFailed),
      tap(async (action) => {
        if (action.data) {
          this.modalService.errorModal(action?.data)
        } else {
          const message = 'Unkown error ocurred. Please try again later.'
          this.modalService.errorModal(message)
        }
      })
    ),
    { dispatch: false }
  );

  getStudentSchedule$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.getStudentSchedule),
      exhaustMap((action) =>
        this.studentService.getStudentSchedule(action?.student_id, action?.term_id).pipe(
          map((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return fromStudentActions.getStudentScheduleSuccess({ data: response?.details })
          }),
          catchError((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return of(fromStudentActions.getStudentScheduleFailed({ data: response?.error?.message }))
          })
        )
      )
    )
  );

  getStudentScheduleSuccess$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.getStudentScheduleSuccess),
      tap(async (action) => {
        this.router.navigateByUrl('/student/calendar')
      })
    ),
    { dispatch: false }
  );

  getStudentScheduleFailed$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromStudentActions.getStudentScheduleFailed),
      tap(async (action) => {
        if (action.data) {
          this.modalService.errorModal(action?.data)
        } else {
          const message = 'Unkown error ocurred. Please try again later.'
          this.modalService.errorModal(message)
        }
      })
    ),
    { dispatch: false }
  );

  getSubjects$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r: RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/subject')
          || r.payload.routerState.url.startsWith('/home/registrar/create-schedule-details')
          || r.payload.routerState.url.startsWith('/home/registrar/update-schedule-details');
      }),
      mergeMap(() => {
        return this.studentService.getSubjects().pipe(
          map((response: APIResponse) => {
            return fromStudentActions.getSubjectsSuccess({ data: response?.details });
          })
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private studentService: StudentService,
    private store: Store<AppState>,
    private modalService: ModalService,
    private router: Router
  ) { }

}
